<template>
  <Plan
    is-pro
    title="Org Pro+"
    description="Organizations plus the power of advanced analytics."
    :price="currentPrice"
    :price-description="`USD per ${interval}`"
    :features="FEATURES"
    :blocks="blocks"
  >
    <template v-if="!$slots.actions" #actions>
      <slot name="actions" />
    </template>

    <slot v-for="slot in Object.keys($slots)" :slot="slot" :name="slot" />
  </Plan>
</template>

<script>
import { computed } from '@nuxtjs/composition-api';
import Plan from './plan';
import { MEMBER_PRICES, ORG_PRO_PLUS, PROFILE_PRICES } from './plans';

const FEATURES = [
  {
    title: 'All of the Org Pro features',
  },
  {
    title: 'Get 3 members included with your plan',
  },
  {
    title: 'View lifetime analytics for all of your profiles',
  },
  {
    title:
      'Analyze your profile traffic in depth with our reporting tools and filtering',
  },
  {
    title: 'Export your analytics data as a .csv',
  },
];

export default {
  components: {
    Plan,
  },

  props: {
    interval: {
      type: String,
      default: 'month',
    },

    profiles: {
      type: Number,
      default: 1,
    },

    members: {
      type: Number,
      default: 1,
    },

    blocks: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const currentPrice = computed(() => {
      const profilePrice =
        PROFILE_PRICES[props.interval] *
        Math.max(props.profiles - ORG_PRO_PLUS.numberOfProfiles, 0);
      const memberPrice =
        MEMBER_PRICES[props.interval] *
        Math.max(props.members - ORG_PRO_PLUS.numberOfUsers, 0);

      return ORG_PRO_PLUS.price[props.interval] + profilePrice + memberPrice;
    });

    return {
      FEATURES,
      currentPrice,
    };
  },
};
</script>

<style lang="scss" scoped></style>
